/**
 * Default values for the User form. Typed against IUserForm so the
 * compiler enforces shape completeness when fields are added.
 */

import { USER_ROLES } from './user.constants';
import type { IUserForm } from './user.types';

export const Model: IUserForm = {
  username: '',
  name: '',
  lastname: '',
  avatar: '',
  country: '',
  country_guid: '',
  role: USER_ROLES.student,
  password: '',
  password_repeat: '',
  change_password: undefined,
  groups: [],
  groupsOld: [],
  schools: [],
  schoolsOld: [],
  school: {},
  is_demo: false,
  is_tangerine_ai: false,
  has_license_mint: false,
  oraculo_id: null,
};

export const ModelAdmin: IUserForm = { ...Model, role: USER_ROLES.admin };
